import React, { Component } from "react";

class LoadingScreen extends Component {
  render() {
    return (
      <div>
        <div className="vw-100 vh-100">
          <div className="row">
            <div className="col vh-center">
              <div className="text-center">
                <img
                  className="spin-logo"
                  src={`/creatifa-icon.png`}
                  alt="creatifa-logo-spin"
                />{" "}
                <span className="text-dark font-poppins">Loading...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LoadingScreen;
